import { useQuery } from '@tanstack/react-query';
import { appLockApi } from '../../api/settings.api.js';
import { useLockStore } from '../../stores/lockStore.js';

/**
 * IS THE ADMIN PIN STANDING IN THE WAY RIGHT NOW?
 *
 * Its own hook because TWO surfaces have to agree on the answer: the gate that
 * draws the keypad, and the settings page's SEARCH, which must not reach into a
 * group the gate is holding shut. Two copies of this condition is the defect
 * where a group is locked on its own URL and readable from the search box —
 * §3.2, on the one fact where being wrong is a security hole rather than a
 * cosmetic one.
 *
 * It is inert unless the tenant enabled the app lock AND set an admin PIN.
 * Configured with neither it passes everyone through, which is why every
 * settings route also carries its own ADMIN/HR check: this is a second gate,
 * never the only one.
 */
export function useAdminLockActive(): boolean {
  const { data: status } = useQuery({
    queryKey: ['app-lock', 'status'],
    queryFn: appLockApi.status,
    staleTime: 60_000,
  });
  const settingsUnlocked = useLockStore((s) => s.settingsUnlocked);
  return Boolean(status?.enabled && status?.hasAdminPin) && !settingsUnlocked;
}
